import { Badge, BadgeColor } from 'components/Display/Badge/Badge';
import { InvoiceVerificationStatus } from 'pages/InvoiceVerification/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ValueOf } from 'support/types';

type InvoiceVerificationStatusBadgeProps = {
  status: InvoiceVerificationStatus | ValueOf<InvoiceVerificationStatus>;
};

export const InvoiceVerificationStatusBadge: FC<InvoiceVerificationStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation();
  const badgeConfiguration = {
    color: BadgeColor.gray,
    text: t('invoiceVerification:status.UNKNOWN'),
  };
  switch (status) {
    case InvoiceVerificationStatus.MATCHED:
      badgeConfiguration.color = BadgeColor.green;
      badgeConfiguration.text = t('invoiceVerification:status.MATCHED');
      break;
    case InvoiceVerificationStatus.AWAITING_DELIVERY_DATA:
      badgeConfiguration.color = BadgeColor.gray;
      badgeConfiguration.text = t('invoiceVerification:status.AWAITING_DELIVERY_DATA');
      break;
    case InvoiceVerificationStatus.REQUIRES_ATTENTION:
      badgeConfiguration.color = BadgeColor.red;
      badgeConfiguration.text = t('invoiceVerification:status.REQUIRES_ATTENTION');
      break;
  }

  return (
    <Badge hasDot color={badgeConfiguration.color}>
      {badgeConfiguration.text}
    </Badge>
  );
};
